export const staticAllTypes = {
  STATIC_ALL_START: "STATIC_ALL_START",
  STATIC_ALL_SUCCESS: "STATIC_ALL_SUCCESS",
  STATIC_ALL_FAILURE: "STATIC_ALL_FAILURE",
};
